// Sender feedback (Ecard /feedback page) — keys match the Ecard server's FEEDBACK_* lists.
export const FEEDBACK_EMOJI = { great: '😀', good: '🙂', ok: '😐', poor: '🙁' };
export const FEEDBACK_LABEL = { great: 'loved it', good: 'good', ok: 'OK', poor: 'not great' };
export const SOURCE_LABEL = { google: 'Google search', bing: 'Bing', facebook: 'Facebook', friend: 'friend or family', received: 'received a CardHero card', other: 'other' };
export const WHY_LABEL = { 'too-late-to-post': 'too late to post', 'far-away': 'far away', cheaper: 'cheaper', easier: 'easier', 'prefer-digital': 'prefer digital', other: 'other' };

// One-line-per-answer summary for hover titles / search.
export function feedbackLines(f) {
  if (!f || !f.rating) return [];
  const lines = [`Rated: ${FEEDBACK_EMOJI[f.rating] || ''} ${FEEDBACK_LABEL[f.rating] || f.rating}`.replace('  ', ' ')];
  if (f.source) lines.push(`Found us: ${SOURCE_LABEL[f.source] || f.source}`);
  if (f.why && f.why.length) lines.push(`Why an ecard: ${f.why.map((w) => WHY_LABEL[w] || w).join(', ')}`);
  if (f.again) lines.push(`Send another: ${f.again}`);
  if (f.fiddly) lines.push(`Fiddly: “${f.fiddly}”`);
  if (f.wish) lines.push(`Wished for: “${f.wish}”`);
  if (f.trustpilotClickedAt) lines.push('★ clicked Trustpilot');
  return lines;
}
